import * as React from "react";
import { useRef, useState } from "react";
import { getThemeColorVar } from "../helper/color";
import { RevoMainMenuItem } from "./revo-main-menu-item";
import classNames from "classnames";
import { Icon } from "../components/icon";
import { filterMenuEntries, renderGroup, } from "./submenus/submenu-entry";
import { appLocationConfig } from "./util/app-location-config";
import { menuTranslations } from "../menu/i18n";
import DropdownButton from "../components/dropdown-button";
import { filterAuthorizedMenuItems, userApps } from "./util/app-authorization";
import { betterServiceUrl } from "../helper/serviceurl";
import { RevoMainMenuFooterItem } from "./revo-main-menu-footer-item";
import { css, cx } from "emotion";
import { getCookieValue } from "../helper/cookies";
import Button from "../components/button";
import RevoMenuItemGroup from "./revo-menu-item-group";
import { reportActiveSection } from "../components/util/location-change";
const oneAppButton = css({
    color: "white",
    padding: "10px 16px",
    width: "100%",
    backgroundColor: `${getThemeColorVar("primary", "default")}`,
    borderRadius: "4px",
});
const footerMenuDefinitions = [
    {
        className: "revoMainMenu__footerUserWrap",
        image: React.createElement(Icon, { name: "profile_male" }),
        links: [
            {
                key: "profileSettings",
                url: betterServiceUrl("lana", "user/profile"),
            },
            {
                key: "securitySettings",
                url: betterServiceUrl("lana", "user/security"),
            },
            {
                key: "logout",
                className: "redText",
                url: betterServiceUrl("login", "logout"),
            },
        ],
    },
    {
        name: "Service",
        className: "revoMainMenu__footerServiceWrap",
        image: React.createElement("div", { className: "revoMainMenu__footerLogo" }),
        links: [
            {
                key: "privacy",
                url: "https://www.21re.de/datenschutz",
            },
            {
                key: "tac",
                url: "https://www.21re.de/agb",
            },
            {
                key: "feedback",
                url: `mailto:support@21re.de`,
            },
            {
                key: "imprint",
                url: "https://www.21re.de/impressum",
            },
            {
                key: "releaseNotes",
                url: "https://sites.google.com/21re.de/release-notes",
            },
        ],
    },
];
const ImpersonatingCookieName = "TS_AUTH_IMPERSONATE";
export const isUserImpersonating = () => getCookieValue(ImpersonatingCookieName) !== null;
export const RevoMainMenu = (props) => {
    const menuTranslation = menuTranslations();
    const isImpersonating = isUserImpersonating();
    const [toolsPopupActive, setToolsPopupActive] = useState(false);
    const toolsPopupHoverDelayTimer = useRef(null);
    const TOOLS_POPUP_HOVER_DELAY_TIMEOUT = 300;
    function mainMenu() {
        const { location } = props;
        const appConfig = appLocationConfig[location.app];
        return renderSubmenu(appConfig);
    }
    function onToolsEntryClick(entry) {
        return (e) => {
            reportActiveSection(entry.app, entry.entry);
            e.preventDefault();
            e.stopPropagation();
            clearToolsPopupTimeout();
            setToolsPopupActive(false);
        };
    }
    function onToolsGroupMouseEnter() {
        clearToolsPopupTimeout();
        if (!toolsPopupActive) {
            setToolsPopupActive(true);
        }
    }
    function onToolsGroupMouseLeave() {
        clearToolsPopupTimeout();
        toolsPopupHoverDelayTimer.current = window.setTimeout(() => {
            setToolsPopupActive(false);
            toolsPopupHoverDelayTimer.current = null;
        }, TOOLS_POPUP_HOVER_DELAY_TIMEOUT);
    }
    function clearToolsPopupTimeout() {
        const timeout = toolsPopupHoverDelayTimer.current;
        if (timeout !== null) {
            toolsPopupHoverDelayTimer.current = null;
            window.clearTimeout(timeout);
        }
    }
    function toolsMenu() {
        const { location } = props;
        const appConfig = appLocationConfig[location.app];
        const menuEntries = appConfig
            .map((entries) => filterMenuEntries(entries, props.scopes).filter((_) => _.toolsPopup))
            .flat();
        if (menuEntries.length > 0) {
            return (React.createElement(RevoMenuItemGroup, { onMouseEnter: props.onMouseEnter, onMouseLeave: () => { } },
                React.createElement("div", { className: "revoMainMenu__menuItem" },
                    React.createElement("div", { className: classNames({
                            revoMenuItem__button: true,
                            impersonate: isImpersonating,
                        }) },
                        React.createElement(Button, { type: "primary", icon: "tools" })),
                    React.createElement("div", { onMouseEnter: onToolsGroupMouseEnter, onMouseLeave: onToolsGroupMouseLeave, className: "revoMenuItem__text__container" },
                        React.createElement("div", { className: "revoMenuItem__text" },
                            React.createElement("span", null, "Tools"),
                            React.createElement("ul", { className: classNames({
                                    "popup-menu": true,
                                    active: toolsPopupActive,
                                }) }, menuEntries.map((entry, index) => (React.createElement("li", { key: "entry-" + index + "-" + entry.entry },
                                React.createElement("a", { href: betterServiceUrl(entry.service, entry.path), onClick: onToolsEntryClick(entry) },
                                    React.createElement("span", null, entry.text)))))))))));
        }
        else {
            return null;
        }
    }
    function renderSubmenu(config) {
        return config.map((i, index) => renderGroup(i, index, props.location.submenu, () => {
            onToolsGroupMouseLeave();
            props.onMouseEnter();
        }, () => undefined, props.location.module, props.location.modulePage, props.scopes, props.location));
    }
    const classes = {
        revoMainMenu__wrapper: true,
        impersonate: isImpersonating,
        "revoMainMenu__wrapper--expanded": props.open,
        "revoMainMenu__wrapper--overlay": props.overlay,
    };
    const renderUserAppInDropDown = filterAuthorizedMenuItems(props.scopes)(userApps);
    const mobileFix = {
        "--windowInnerHeight": `${window.innerHeight}px`,
    };
    const { appTitle } = props;
    const dropdownActions = Object.keys(renderUserAppInDropDown).map((key) => {
        const appItem = renderUserAppInDropDown[key];
        return {
            title: menuTranslation.apps[key].title,
            onClick: () => (window.location.href = `${betterServiceUrl(appItem.service, appItem.path)}`),
        };
    });
    const topDropdownApps = new Set(Object.keys(renderUserAppInDropDown)).add(props.location.app);
    const showAppSelectionDropdown = topDropdownApps.size > 1;
    const footerMenuWithTools = footerMenuDefinitions;
    return (React.createElement("div", { className: classNames(classes), onMouseLeave: props.onMouseLeave },
        React.createElement("div", { style: mobileFix, className: "revoMainMenu__menu" },
            React.createElement("div", { className: "revoMainMenu__menuWrap" },
                React.createElement("div", { className: "revoMainMenu__menuToggleWrapper" }, appTitle && (React.createElement(RevoMainMenuItem, { location: props.location, text: appTitle, icon: props.open ? "close" : "menu_default", tooltip: !props.overlay ? menuTranslation.menuTeaser : undefined, onClick: () => props.toggleMainMenu(), logo: true, scopes: props.scopes, isImpersonating: isImpersonating }))),
                React.createElement("div", { className: "revoMainMenu__menuToggleWrapper" },
                    React.createElement("div", { className: "revoMainMenu__menuItem revoMainMenu__wrapAppsList" },
                        React.createElement("div", { className: classNames({
                                revoMainMenu__blankSpace: true,
                                impersonate: isImpersonating,
                            }) }),
                        showAppSelectionDropdown ? (React.createElement("div", { className: !props.open
                                ? "revoMainMenu__dropMenu"
                                : cx("revoMainMenu__dropMenu", css({ transition: "transform 0s ease-in-out" })) },
                            React.createElement(DropdownButton, { actions: dropdownActions, type: "primary", autoClose: props.open ? undefined : !props.menuIsHovered }, appTitle))) : (React.createElement("div", { style: { width: "100%", padding: "16px" } },
                            React.createElement("div", { className: !props.open
                                    ? cx("revoMainMenu__dropMenu", oneAppButton)
                                    : cx("revoMainMenu__dropMenu", oneAppButton, css({ transition: "transform 0s ease-in-out" })) }, appTitle))))),
                React.createElement("div", { className: "revoMainMenu__itemsWrapper" },
                    mainMenu(),
                    toolsMenu()),
                appTitle && (React.createElement("div", { className: "revoMainMenu__itemWrapper revoMainMenu__footerWrapper" }, footerMenuWithTools.map((footerMenuDef, index) => {
                    var _a, _b, _c, _d, _e;
                    return (React.createElement("div", { className: footerMenuDef.className, key: index, onMouseEnter: props.onMouseEnter },
                        React.createElement("div", { className: "revoMainMenu__footerLogoWrap" }, footerMenuDef.image),
                        React.createElement(RevoMainMenuFooterItem, { name: footerMenuDef.name ||
                                (props.user && ((_a = props.user) === null || _a === void 0 ? void 0 : _a.name.length) > 0
                                    ? `${(_b = props.user) === null || _b === void 0 ? void 0 : _b.name} ${(_c = props.user) === null || _c === void 0 ? void 0 : _c.surname}`
                                    : `21st Real Estate`), links: footerMenuDef.links, companyId: (_e = (_d = props.user) === null || _d === void 0 ? void 0 : _d.companyId) !== null && _e !== void 0 ? _e : null })));
                }))))),
        React.createElement("div", { className: "revoMainMenu__backgroundWrapper" },
            React.createElement("div", { style: {
                    backgroundColor: isImpersonating
                        ? "red"
                        : getThemeColorVar("primary", "default"),
                    pointerEvents: "auto",
                } }),
            React.createElement("div", { style: { backgroundColor: "white" } }))));
};
//# sourceMappingURL=revo-main-menu.js.map